<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-50 md-size-50">
			<h4>{{translate(locale.allManager)}}</h4>
		</div>
		<!-- <div class="md-layout-item md-medium-size-50 md-size-50 text-right">
			<md-button class="md-raised md-primary">{{translate(locale.addNewManager)}}</md-button>
		</div> -->
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
					<loading v-if="!loaded" />
					<div v-if="loaded">
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-50">
								<md-field>
									<label>{{translate(locale.searchManager)}}</label>
									<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-30 md-size-25">
								<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">{{translate(locale.search)}}</md-button>
							</div>
						</div>
						<md-table v-if="managerList.length > 0">
							<md-table-row>
								<md-table-head></md-table-head>
								<md-table-head>{{translate(locale.userName)}}</md-table-head>
								<md-table-head>{{translate(locale.userContact)}}</md-table-head>
								<md-table-head>{{translate(locale.userRole)}}</md-table-head>
								<!-- <md-table-head>{{translate(locale.action)}}</md-table-head> -->
							</md-table-row>

							<md-table-row v-for="(manager, index) in managerList">
								<!-- <md-table-cell></md-table-cell> -->
								<md-table-cell>​{{ index + 1 }}</md-table-cell>
								<md-table-cell>
									<div style="display: flex; flex-direction: row; align-items: center;">
										<img src="@/assets/img/default.png" style="width:40px;margin-right: 8px;"/>
										<span><b>{{manager.first_name}} {{manager.last_name}}</b><br>{{config.getGender(manager.gender)}}</span>
									</div>
								</md-table-cell>
								<md-table-cell><b>+{{manager.phone_number}}</b><br>{{manager.email}}</md-table-cell>
								<md-table-cell><b>
									<span v-if="manager.role == 'super-admin'">{{translate(locale.roleSuperAdmin)}}</span>
									<span v-if="manager.role == 'admin'">{{translate(locale.roleAdmin)}}</span>
									<span v-if="manager.role == 'editor'">{{translate(locale.roleEditor)}}</span>
								</b></md-table-cell>
								<md-table-cell>
									
								</md-table-cell>
							</md-table-row>
						</md-table>
						<h5 class="text-center" v-if="managerList.length == 0 && loaded == true">You don't have any manager offers.</h5>
						<div class="places-buttons text-center" v-if="loadMore">
							<md-button class="md-primary" @click="searchHandler(true)">{{translate(locale.showMore)}}</md-button>
						</div>
					</div>

					<md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="Are you sure want to delete this manager ?" :md-confirm-text="translate(locale.delete)"
						:md-cancel-text="translate(locale.cancel)" @md-cancel="onCancel" @md-confirm="onDelete" />
						<md-dialog-confirm :md-active.sync="disableDialogActive" md-title="Are you sure want to disable this manager ?" :md-confirm-text="translate(locale.disable)"
						:md-cancel-text="translate(locale.cancel)" @md-cancel="onCancel" @md-confirm="onDisable" />
				</md-card-content>
			</md-card>
		</div>
	</div>
		
	</div>

</template>

<script>

	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
		},

		data() {
			return {
				loaded: false,
				deleteDialogActive: false, deleteSelected: '',
				disableDialogActive: false, disableSelected: '',
				search: { text: "", status: "", type: "" },
				loadMore: false,
				managerList: []
			}
		},
		methods: {
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/profile/manager/search", {
					text: this.search.text,
					role: this.search.status,
					offset: more ? this.managerList.length : 0
				}).then(data => {
					this.loaded = true;
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.managerList = more ? this.managerList.concat(data.body.data) : data.body.data;
				})
			},

			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},
			onDelete(hash) {
				if(this.deleteSelected == "") {
					this.deleteDialogActive = true;
					this.deleteSelected = hash;
					return;
				}
				this.$http.post(this.config.api + "/profile/scholarship/delete", {
					hash: this.deleteSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have deleted the quotation/bidding successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onDisable(hash) {

				if(this.disableSelected == "") {
					this.disableDialogActive = true;
					this.disableSelected = hash;
					return;
				}
				this.$http.post(this.config.api + "/profile/scholarship/disable", {
					hash: this.disableSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have disabled the quotation/bidding successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},

			onEnable(hash) {

				this.$http.post(this.config.api + "/profile/scholarship/enable", {
					hash: hash
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have enabled the quotation/bidding successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.disableSelected = ""
				this.deleteDialogActive = false
				this.disableDialogActive = false
			},	
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/MyManagers/View.vue